// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer {
    display: flex;
    justify-content: center;
  }
  
  .modal-footer .btn-primary {
    margin-right: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/app/shared/component/confirmdialog/confirmdialog.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":[".modal-footer {\n    display: flex;\n    justify-content: center;\n  }\n  \n  .modal-footer .btn-primary {\n    margin-right: 20px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
